import React from "react";
import Typography from "@mui/material/Typography";

const HelpModulePhoneHeader = props => {
	return (
		<React.Fragment>
			<Typography variant="h1">
				Call Toll-Free
			</Typography>
			<Typography component="p" sx={{ mb: 2, mt: 3 }} variant="h2">
				1-800-233-0751
			</Typography>
			<Typography gutterBottom={false}>
				Monday through Friday 8:00 AM to 9:00 PM (ET)<br />
				United States, Canada
			</Typography>
		</React.Fragment>
	);
};

const HelpModulePhone = props => {
	return (
		<React.Fragment>
			<Typography component="h2" variant="h5">
				International
			</Typography>
			<Typography component="p" sx={{ mb: 1, mt: 2 }} variant="h2">
				717-720-3400
			</Typography>
			<Typography gutterBottom={false}>
				Monday through Friday 8:00 AM to 9:00pm (ET)
			</Typography>
			<Typography component="h2" sx={{ mt: 6 }} variant="h5">
				TTY #
			</Typography>
			<Typography component="p" variant="h2" sx={{ mb: 1, mt: 2 }}>
				Dial 711
			</Typography>
			<Typography>
				Support for hearing and speech-impaired callers.<br />
				Monday through Friday 8:00 AM to 5:00 PM (ET)
			</Typography>
			<Typography sx={{ mt: 6 }}>
				Our interactive voice response system is avaiable 24 hours per day (except for occasional maintenance).
			</Typography>
		</React.Fragment>
	);
};

export default HelpModulePhone;
export { HelpModulePhoneHeader };